export enum LogLevel {
    ERROR='ERROR',
    WARNING='WARNING',
    INFO='INFO',
    FATAL='FATAL'
}

export interface Log {
    level: LogLevel,
    message: string,
    context: string,
    stackTrace?: string,
}

export interface LogEx extends Log {
    windowUrl:string,
    userId:string
    timestamp: string,
    transactionId: string
}